import {
  createSharingProc,
  updateSharingProc,
  bulkUpdateSharingProc,
  bulkCreateSharingProc,
  readSharingProc,
  deleteSharingProc,
  flushSharingForTesting,
} from '@/appLogic/leanpath/wrappers';
import { CacheManage, clearDriversTable, getTable, initCacheDataWithDummyDriver, prepareTable } from '@/appLogic/common/cacheManage';

const tableName = 'sharingTbl';

let sharingTable: CacheManage;
/**
 *
 */
const getSharingTableSync = () => sharingTable;

/**
 *
 */
const clearSharingTable = async () => {
  await getSharingTableSync().flush();
  await clearDriversTable(tableName);
};

/**
 *
 */
const clearSharingDataInServer = async () => {
  await clearSharingTable();
  await getSharingTableSync().flushForTesting();
};

/**
 *
 * @param connectServer
 */
const prepareSharingTable = async (connectServer = true) => {
  if (connectServer) {
    sharingTable = await prepareTable(tableName, 'sellerId', 'dataId', undefined, {
      createAdapter: createSharingProc,
      updateAdapter: updateSharingProc,
      bulkCreateAdapter: bulkCreateSharingProc,
      bulkUpdateAdapter: bulkUpdateSharingProc,
      readAdapter2: readSharingProc,
      deleteAdapter: deleteSharingProc,
      flushForTestingAdapter: flushSharingForTesting,
    });
  } else {
    await initCacheDataWithDummyDriver(tableName, 'sellerId', 'dataId', 'buyerId');
    sharingTable = await getTable(tableName);
  }
  sharingTable.setGsi('buyerId');
};

export { tableName, prepareSharingTable, getSharingTableSync, clearSharingTable, clearSharingDataInServer };
